import { Component } from '@angular/core';

@Component({
    selector: 'app-companies',
    template: `<router-outlet></router-outlet>`,
})
export class CompaniesPage {}
